import React from 'react';
import { Route, IndexRoute } from 'react-router';
import SearchContainer from 'split-chunk-loader?lazy!../Search/SearchContainer';
import { lazify } from '../Common/Helper';

const SearchRoute = (
  <Route label="Search" path="search" component={lazify(SearchContainer)}>
    <IndexRoute>
    </IndexRoute>
  </Route>
);

export default SearchRoute;



// WEBPACK FOOTER //
// ./src/Routes/Search.js